import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import MockResizeObserver from "./utils/MockResizeObserver";

const Resize = _ref => {
  let {
    render,
    onChange = () => null
  } = _ref;
  const [resizeRef, entry] = useResize(onChange);
  return render({
    refHandler: resizeRef,
    entry
  });
};

Resize.propTypes = {
  /** Render prop with `refHandler` and `entry` (a [ResizeObserverEntry]()https://drafts.csswg.org/resize-observer-1/#resize-observer-entry-interface) */
  render: PropTypes.func.isRequired,

  /** Callback to execute when resize events occur */
  onChange: PropTypes.func
};
export default Resize;
export const useResize = onChange => {
  const [entry, setEntry] = useState({});
  const observer = useRef(null);
  const node = useRef(null);
  useEffect(() => {
    const handleResize = _ref2 => {
      let [resizeEntry] = _ref2;
      setEntry(resizeEntry);

      if (onChange) {
        onChange(resizeEntry);
      }
    };

    if (node.current && !observer.current) {
      if (typeof ResizeObserver !== "undefined") {
        observer.current = new ResizeObserver(handleResize);
      } else {
        observer.current = new MockResizeObserver(handleResize);
      }

      observer.current.observe(node.current);
    }

    const current = node.current;
    return () => {
      if (current) {
        observer.current.disconnect();
        observer.current = null;
      }
    };
  }, [onChange]);
  return [node, entry];
};